const points = [
  {
    title: 'ހުރިހާ އެއްޗަކަށް އެއް ލޮގިން',
    body: 'އެންމެ ވެޕްލިފައި އޮފީސް އެކައުންޓަކުން ޓީމުގެ ހުރިހާ މީހުން ކޮންމެ ޕްރޮޑަކްޓަކަށްވެސް ވަދެވޭ — ދެވަނަ ސައިން-އިނެއް ނެތި.',
  },
  {
    title: 'ސެންޓްރަލް ޔޫޒަރުންނާއި ރޯލްތައް',
    body: 'މީހުން އެއްފަހަރު ދައުވަތުދީ، ކޮންމެ އެޕެއްގައި އެ މީހަކަށް ކުރެވޭނެ ކަންކަން އެއް ތަނަކުން ކަނޑައަޅާ.',
  },
  {
    title: 'އޯގަނައިޒޭޝަން، ގުޅުވާލެވިފައި',
    body: 'ތިޔަ ކައުންސިލް ބިނާވެފައި ވަނީ ވެޕްލިފައި އޮފީހުގައި، އަދި ގުޅިފައިވާ ކޮންމެ އެޕެއްގައި އެއްގޮތަކަށް ދެމިއޮވޭ.',
  },
  {
    title: 'ސޮއި އަދި ޕްރޮފައިލް އެއްފަހަރު',
    body: 'ނަން، މަޤާމު އަދި ސޮއި އެއްފަހަރު ބަލަހައްޓައި، ފެންނަ ކޮންމެ ތަނެއްގައި ބޭނުންކުރެވޭ.',
  },
];

/**
 * The "why" section, on the open page.
 *
 * This used to be a full-bleed primary-container band carrying four tonal
 * cards — a solid colour block holding four more colour blocks, which was the
 * single heaviest thing on the landing. It is now type in a four-up grid, with
 * a hairline above each point as the only division.
 */
export function WhyOffice(): JSX.Element {
  return (
    <section id="why" className="folio-wide scroll-mt-24 py-20 sm:py-28">
      <div className="reveal max-w-2xl">
        <span className="chip-dv">ކޮލޮފޮން</span>
        <h2 className="head-dv mt-3 text-[2rem] leading-[1.35] sm:text-[2.7rem] sm:leading-[1.3]">
          ލޯކަލް ކައުންސިލްތަކަށް{' '}
          <span className="text-[hsl(var(--primary))]">ޚާއްޞަކޮށް ފަރުމާކުރެވިފައި</span>
        </h2>
        <p className="mt-5 leading-loose text-muted-foreground">
          ވެޕްލިފައި އޮފީހަކީ ރަށު ކައުންސިލްތަކުގެ އިދާރީ ހިންގުން ޑިޖިޓަލައިޒް ކުރުމަށް އަމާޒުކޮށްފައިވާ ޚިދުމަތެއް.
          ކައުންސިލްތަކުގެ މަސައްކަތުގެ ވައްޓަފާޅިއަށް ޚާއްޞަކޮށް ފަރުމާކުރެވިފައިވާ، ދުވަހުން ދުވަހަށް އިތުރުވަމުންދާ
          ޓޫލްތަކަކުން ދުވަހީ މަސައްކަތްތައް ފަސޭހަކޮށް، ހަލުވިކޮށް އަދި ރައްކާތެރިކޮށްދެނީ.
        </p>
      </div>

      <ul className="mt-16 grid gap-x-12 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
        {points.map((p, i) => (
          <li
            key={p.title}
            className="reveal border-t border-[hsl(var(--border))]/60 pt-5"
            style={{ '--reveal-delay': `${i * 80}ms` } as React.CSSProperties}
          >
            <h3 className="head-dv text-lg leading-snug">{p.title}</h3>
            <p className="mt-3 text-sm leading-loose text-muted-foreground">{p.body}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
